module.exports = __webpack_public_path__ + "static/img/IMG_20161119_132722.412aa67b.jpg";